<template>
  <div class="big doctorActivityStatistics">
    <ImportExcel
      :isFlag="isImport"
      interfaceName="importDoctorHeartActivityData"
      :paramsObj="paramsObj"
      :isMonth="true"
      :isConfirm="true"
      :tableHeader="importTableHeader"
      confirmInterfaceName="confirmAddActivityData"
      paramsKey="act_pic"
      temName="act_pic"
      @refreshList="refreshList"
    ></ImportExcel>
    <div class="page_title flex_between">
      <span>{{pageTitle}}</span>
      <el-button
        type="primary"
        style="width: 92px"
        size="medium"
        @click="back"
      >返回</el-button>
    </div>

    <div style="padding: 20px; border-radius: 5px">
      <div
        class="container"
        style="padding: 10px 20px 20px 20px;"
      >

        <div class="statistics-card">
          <!-- 开方金额 -->
          <el-card class="box-card">
            <div class="desc">
              <div class="value">
                <span class="val-1">￥{{countData.all_total_money}} </span>
                <span class="val-2">({{countData.all_total_money_no_settle}})</span>
                <span>
                  <el-popover
                    placement="bottom"
                    trigger="hover"
                    content="总开方数量（待结算开方数量）"
                  >
                    <el-button
                      slot="reference"
                      type="text"
                    ><i class="el-icon-question"></i></el-button>
                  </el-popover>
                </span>
              </div>
              <div class="title">开方金额</div>

            </div>
          </el-card>
          <!-- 药费金额 -->
          <el-card class="box-card">
            <div class="desc">
              <div class="value">
                <span class="val-1">￥{{countData.all_drug_money}} </span>
                <span class="val-2">({{countData.all_drug_money_no_settle}})</span>
                <span>
                  <el-popover
                    placement="bottom"
                    trigger="hover"
                    content="已发放开方药费总额（待发放开方药费总额）"
                  >
                    <el-button
                      slot="reference"
                      type="text"
                    ><i class="el-icon-question"></i></el-button>
                  </el-popover>
                </span>
              </div>
              <div class="title">药费金额</div>
            </div>
          </el-card>
          <!-- 仁心值奖励 -->
          <el-card class="box-card">
            <div class="desc">
              <div class="value">
                <span class="val-1">￥{{countData.all_heart_multiple}} </span>
                <span class="val-2">({{countData.all_heart_multiple_no_settle}})</span>
                <span>
                  <el-popover
                    placement="bottom"
                    trigger="hover"
                    content="已奖励仁心值数量（预计奖励数量）"
                  >
                    <el-button
                      slot="reference"
                      type="text"
                    ><i class="el-icon-question"></i></el-button>
                  </el-popover>
                </span>
              </div>
              <div class="title">仁心值奖励</div>
            </div>
          </el-card>
        </div>

        <div class="search-box">

          <div class="item">
            <span style="margin-left:10px">医生姓名</span>
            <el-input
              v-model="activityForm.doctor_name"
              clearable
              size="small"
              style="width:180px"
              placeholder="医生姓名"
              @change="seachEnterFun"
            ></el-input>
          </div>
          <div class="item">
            <span style="margin-left:10px">医生手机号</span>
            <el-input
              v-model="activityForm.phone"
              clearable
              size="small"
              style="width:180px"
              placeholder="医生手机号"
              @change="seachEnterFun"
            ></el-input>
          </div>
          <!-- 是否测试医生 -->
          <div class="item">
            <div style="margin-left:10px">是否测试医生</div>
            <span>
              <el-radio-group
                v-model="activityForm.is_test"
                @change="seachEnterFun"
              >
                <el-radio :label="-1">全部</el-radio>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </span>
            <el-button
              type="primary"
              size="small"
              style="margin-left:20px"
              @click="getList"
            >查询</el-button>
            <el-button
              size="small"
              @click="restBtn"
            >重置</el-button>
            <el-button
              type="primary"
              size="small"
              :disabled=" module_id_array[0] ? !module_id_array.includes('1079') : false"
              @click="addDetail"
            >导入活动数据</el-button>
          </div>
        </div>

        <div class="prompt">
          注:每月1-5号为数据结算期,上月数据可能会出现为空情况,请耐心等待
        </div>

        <div style="border: solid 1px #c9cbd6;">
          <el-table
            v-loading="tableLoading"
            :data="benevolenceData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @sort-change="sortChange"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
              :sortable="item.sortable"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'doctor_info'">
                  <div style="cursor:pointer">{{ scope.row.doctor_name }}</div>
                  <div>{{ scope.row.phone }}</div>
                </div>
                <div v-else-if="item.prop == 'last_month_drug_money'">
                  {{ `${scope.row.last_month_drug_money?`${scope.row.last_month_drug_money}元`:'-'}/${scope.row.last_month_heart_multiple?`${scope.row.last_month_heart_multiple}仁心值`:'-'}` }}
                </div>
                <div v-else-if="item.prop == 'month_drug_money'">
                  {{ `${scope.row.month_drug_money ? `${scope.row.month_drug_money}元` :'-'}/${scope.row.month_heart_multiple?`${scope.row.month_heart_multiple}仁心值`:'-'}` }}
                </div>
                <div v-else>
                  {{ JSON.stringify(scope.row[item.prop]) === 'null' ? '' : scope.row[item.prop] }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="toDetail(scope.row)"
                  :disabled="module_id_array[0] ? !module_id_array.includes('1080') : false"
                >详情</el-button>
                <el-button
                  type="text"
                  @click="setRemark(scope.row)"
                  :disabled="module_id_array[0] ? !module_id_array.includes('1077') : false"
                >备注</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum>0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
  </div>

</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import marketing from '@/api/marketing.js';
import Pagination from '@/components/Pagination/index';
import ImportExcel from '@/components/importExcel/index.vue';
export default {
  components: {
    Pagination,
    ImportExcel
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      pageTitle: '',
      countData: {},
      activityForm: {
        doctor_name: '',
        phone: '',
        is_test: -1
      },
      tableHeader: [
        {
          label: '医生信息',
          prop: 'doctor_info',
          width: 'auto',
          align: 'center',
          fixed: 'left',
          sortable: false
        },
        {
          label: '已发放开方金额',
          prop: 'total_money',
          width: 'auto',
          align: 'center',
          fixed: false,
          sortable: 'custom'
        },
        {
          label: '已发放药费金额',
          prop: 'drug_money',
          width: 'auto',
          align: 'center',
          fixed: false,
          sortable: 'custom'
        },
        {
          label: '上月已结算数据/奖励',
          prop: 'last_month_drug_money',
          width: '180',
          align: 'center',
          fixed: false,
          sortable: 'custom'
        },
        {
          label: '当月预计数据/奖励',
          prop: 'month_drug_money',
          width: '180',
          align: 'center',
          fixed: false,
          sortable: 'custom'
        },
        {
          label: '已解锁奖励节点',
          prop: 'rule_name',
          width: 'auto',
          align: 'center',
          fixed: false,
          sortable: false
        },
        {
          label: '备注',
          prop: 'remark',
          width: 'auto',
          align: 'center',
          fixed: false,
          sortable: false
        }
      ],
      importTableHeader: [
        {
          label: '数据条数',
          prop: 'total_num',
          width: 'auto'
        },
        {
          label: '医生人数总计',
          prop: 'doctor_num',
          width: '120'
        },
        {
          label: '开方总金额（已发货）',
          prop: 'total_money',
          width: '120'
        },
        {
          label: '药费总金额（已发货）',
          prop: 'total_drug_money',
          width: '120'
        },
        {
          label: '开方药费奖励仁心值',
          prop: 'total_heart_multiple',
          width: '120'
        },
        {
          label: '进阶奖励仁心值',
          prop: 'total_heart',
          width: '120'
        }
      ],
      sortParams: {
        order_key: '',
        order_value: ''
      },
      benevolenceData: [],
      isImport: false,
      paramsObj: {
        act_id: this.$route.query.act_id
      }
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD HH:mm');
    },
    preGroupText(val) {
      switch (val) {
        case -1:
          return '成药';
        case 0:
          return '养生膏方';
        case 1:
          return '颗粒';
        case 2:
          return '饮片';
        case 3:
          return '膏方';
        case 4:
          return '丸剂';
      }
    },
    statusText(val) {
      switch (val) {
        case 1:
          return '待取药';
        case 2:
          return '待审方';
        case 3:
          return '已通过';
        case 4:
          return '已抓药';
        case 5:
          return '已失效[过期未取药]';
        case 6:
          return '已失效[审方不通过]';
        case 7:
          return '已失效[医生手动作废]';
        case 8:
          return '已失效[平台退款]';
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    routeQuery() {
      return this.$route.query;
    }
  },
  created() {
    this.getTotalCount();
    this.getList();
  },
  methods: {
    getTotalCount() {
      let { act_id } = this.routeQuery;
      const loading = this.$loading();
      marketing
        .doctorHeartActivityTotalCount({ act_id })
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.pageTitle = data.title;
            this.countData = data.count_data;
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    getList() {
      let { act_id } = this.routeQuery;
      let params = Object.assign(
        this.pagination,
        this.activityForm,
        {
          act_id
        },
        this.sortParams
      );
      this.tableLoading = true;
      marketing.doctorHeartActivityCount(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.benevolenceData = data.list.map((item) => {
            item.last_month_drug_money = Number(item.last_month_drug_money);
            item.month_drug_money = Number(item.month_drug_money);
            return item;
          });
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    addDetail() {
      let startTime = dayjs.unix(this.routeQuery.start_time).startOf('month');
      let currentTime = dayjs().startOf('month');
      if (currentTime < startTime) {
        this.$message.warning('当前时间不支持导入');
        return;
      }
      this.isImport = !this.isImport;
    },
    restBtn() {
      for (let key in this.activityForm) {
        if (key == 'create_time') {
          this.activityForm[key] = [];
        } else {
          this.activityForm[key] = '';
        }
      }
      this.getList();
    },
    // 详情
    toDetail(row) {
      let { doctor_id, month_heart_multiple } = row;
      this.$router.push({
        path: '/home/marketing/statisticsDetails',
        query: {
          act_id: this.routeQuery.act_id,
          doctor_id,
          month_heart_multiple: month_heart_multiple ? month_heart_multiple : 0
        }
      });
    },
    // 备注
    setRemark(row) {
      let { doctor_id } = row;
      this.$prompt('', '请输入备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false
      })
        .then(({ value }) => {
          if (value.length >= 50) {
            this.$message.error('备注不超过50个字');
            return false;
          }
          let params = {
            act_id: this.routeQuery.act_id,
            doctor_id: doctor_id,
            remark: value
          };
          marketing.doctorHeartActivityRemark(params).then((res) => {
            if (res.code == 0) {
              this.$message.success('保存成功');
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    refreshList() {
      this.getTotalCount();
      this.getList();
    },
    sortChange(value) {
      let { order, prop } = value;
      //升序
      if (order == 'ascending') {
        this.sortParams.order_value = 'asc';
      }
      //降序
      if (order == 'descending') {
        this.sortParams.order_value = 'desc';
      }
      this.sortParams.order_key = prop;
      if (!order) {
        this.sortParams = {
          order_key: '',
          order_value: ''
        };
      }
      this.getList();
    },
    back() {
      history.back();
    }
  }
};
</script>

<style lang="scss" scoped >
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.doctorActivityStatistics {
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
  .prompt {
    font-size: 12px;
    text-align: left;
    color: red;
    padding-left: 10px;
    margin-bottom: 10px;
  }
  .statistics-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .box-card {
      width: 30%;
      ::v-deep .el-card__body {
        display: flex;
        align-items: center;
        justify-content: space-around;
        .desc {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .value {
            font-size: 20px;
            font-weight: bold;
            .val-1 {
              color: #669961;
            }
            .val-2 {
              font-size: 16px;
              font-weight: normal;
            }
          }
          .title {
            padding: 10px 0;
          }
        }
      }
    }
  }
}
</style>